/* Builds the sticky table of contents from the article's h2 headings. */
(function () {
  var toc = document.querySelector('[data-toc]');
  var prose = document.querySelector('.prose');
  if (!toc || !prose) return;
  var heads = prose.querySelectorAll('h2');
  if (heads.length < 2) return;
  heads.forEach(function (h, i) {
    if (!h.id) h.id = 'h-' + (i + 1);
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    toc.appendChild(a);
  });
  toc.hidden = false;
})();
